import {Map} from 'immutable';
import {
  LIST_OPERATORS,
  CREATE_OPERATOR,
  UPDATE_OPERATOR_MGR,
  STOP_OPERATOR,
  START_OPERATOR,
  RESTART_OPERATOR,
  GET_KANNEL_STATUS,
  LIST_OPERATOR_HEALTH,
  GET_ROUTE_CHAIN,
  SET_OPERATOR_ROUTE,
  REMOVE_OPERATOR_ROUTE,
  GET_GLOBAL_ROUTING_CONFIG,
  UPDATE_GLOBAL_ROUTE,
  ENABLE_FORCE_GLOBAL,
  DISABLE_FORCE_GLOBAL,
  LIST_TENANT_ROUTES,
  BULK_SET_OPERATOR_ROUTE,
  LIST_KANNEL_BOXES,
  UPSERT_KANNEL_BOX,
  LIST_BOX_OPERATORS,
  SET_BOX_OPERATORS,
  LIST_BOX_SMSBOXES,
  SET_BOX_SMSBOXES
} from '../lib/constant';

const initialState = Map({
  listOperatorsResponse: {},
  createOperatorResponse: {},
  updateOperatorResponse: {},
  stopOperatorResponse: {},
  startOperatorResponse: {},
  restartOperatorResponse: {},
  kannelStatusResponse: {},
  operatorHealthResponse: {},
  routeChainResponse: {},
  setRouteResponse: {},
  removeRouteResponse: {},
  globalRoutingConfigResponse: {},
  updateGlobalRouteResponse: {},
  enableForceGlobalResponse: {},
  disableForceGlobalResponse: {},
  listTenantRoutesResponse: {},
  bulkSetRouteResponse: {},
  listKannelBoxesResponse: {},
  upsertKannelBoxResponse: {},
  listBoxOperatorsResponse: {},
  setBoxOperatorsResponse: {},
  listBoxSmsboxesResponse: {},
  setBoxSmsboxesResponse: {}
});

export default function(state = initialState, action) {
  switch(action.type) {
    case LIST_OPERATORS:
      return {...state, listOperatorsResponse: action.payload};
    case CREATE_OPERATOR:
      return {...state, createOperatorResponse: action.payload};
    case UPDATE_OPERATOR_MGR:
      return {...state, updateOperatorResponse: action.payload};
    case STOP_OPERATOR:
      return {...state, stopOperatorResponse: action.payload};
    case START_OPERATOR:
      return {...state, startOperatorResponse: action.payload};
    case RESTART_OPERATOR:
      return {...state, restartOperatorResponse: action.payload};
    case GET_KANNEL_STATUS:
      return {...state, kannelStatusResponse: action.payload};
    case LIST_OPERATOR_HEALTH:
      return {...state, operatorHealthResponse: action.payload};
    case GET_ROUTE_CHAIN:
      return {...state, routeChainResponse: action.payload};
    case SET_OPERATOR_ROUTE:
      return {...state, setRouteResponse: action.payload};
    case REMOVE_OPERATOR_ROUTE:
      return {...state, removeRouteResponse: action.payload};
    case GET_GLOBAL_ROUTING_CONFIG:
      return {...state, globalRoutingConfigResponse: action.payload};
    case UPDATE_GLOBAL_ROUTE:
      return {...state, updateGlobalRouteResponse: action.payload};
    case ENABLE_FORCE_GLOBAL:
      return {...state, enableForceGlobalResponse: action.payload};
    case DISABLE_FORCE_GLOBAL:
      return {...state, disableForceGlobalResponse: action.payload};
    case LIST_TENANT_ROUTES:
      return {...state, listTenantRoutesResponse: action.payload};
    case BULK_SET_OPERATOR_ROUTE:
      return {...state, bulkSetRouteResponse: action.payload};
    case LIST_KANNEL_BOXES:
      return {...state, listKannelBoxesResponse: action.payload};
    case UPSERT_KANNEL_BOX:
      return {...state, upsertKannelBoxResponse: action.payload};
    case LIST_BOX_OPERATORS:
      return {...state, listBoxOperatorsResponse: action.payload};
    case SET_BOX_OPERATORS:
      return {...state, setBoxOperatorsResponse: action.payload};
    case LIST_BOX_SMSBOXES:
      return {...state, listBoxSmsboxesResponse: action.payload};
    case SET_BOX_SMSBOXES:
      return {...state, setBoxSmsboxesResponse: action.payload};
    default:
      return state;
  }
}
